/**
 * Formats a phone number to US format (XXX) XXX-XXXX
 * @param value - Raw phone number string
 * @returns Formatted phone number
 */
export function formatPhone(value: string): string {
	const digits = value.replace(/\D/g, '').slice(0, 10)
	const part1 = digits.slice(0, 3)
	const part2 = digits.slice(3, 6)
	const part3 = digits.slice(6, 10)
	if (digits.length > 6) return `(${part1}) ${part2}-${part3}`
	if (digits.length > 3) return `(${part1}) ${part2}`
	if (digits.length > 0) return `(${part1}`
	return ''
}

/**
 * Converts E.164 format (+1XXXXXXXXXX) to US display format (XXX) XXX-XXXX
 * @param e164Phone - Phone number in E.164 format
 * @returns Formatted phone number for display
 */
export function e164ToFormatted(e164Phone: string): string {
	if (e164Phone.startsWith('+1')) {
		const digits = e164Phone.slice(2) // Remove +1
		return formatPhone(digits)
	}
	return e164Phone
}

/**
 * Converts formatted phone (XXX) XXX-XXXX to E.164 format (+1XXXXXXXXXX)
 * @param formattedPhone - Phone number in formatted display format
 * @returns Phone number in E.164 format
 */
export function formattedToE164(formattedPhone: string): string {
	const digits = formattedPhone.replace(/\D/g, '')
	return `+1${digits}`
}

/**
 * Validates if a phone number is in correct US format
 * @param phone - Phone number to validate
 * @returns True if valid format or empty
 */
export function isValidPhoneFormat(phone: string): boolean {
	return /^(\(\d{3}\) \d{3}-\d{4})$/.test(phone) || phone === ''
}
